import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { baseUrl } from "../../config/baseUrl";
import MultiSelectDropdown from "./multi-select-dropdown";
import { Bounce, toast } from "react-toastify";

export const EduUsersAdd = ({
  userType,
  forceUpdate,
  setForceUpdate,
  activateEduUserAdd,
  setActivateEduUserAdd,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [campusId, setCampusId] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const [userTypeSelect, setUserTypeSelect] = useState("");
  const [campusList, setCampusList] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const localUserType = JSON.parse(localStorage.getItem("user"))?.user_type;

  const getCampusList = async () => {
    try {
      let response = await axios(`${baseUrl}/get_campus/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      setCampusList(
        response?.data?.data?.map((m) => ({
          id: m?.id,
          campus_name: m?.campus_name,
        }))
      );
    } catch (err) {
      console.error("Error fetching campus list", err);
    }
  };

  // ✅ Fetch company list
  const getCompanyList = async () => {
    try {
      let response = await axios(`${baseUrl}/list_get_company/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      setCompanyList(response?.data?.data || []);
    } catch (err) {
      console.error("Error fetching company list", err);
    }
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create FormData object
    const formData = new FormData();

    // Add all the data fields
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("password", password);
    formData.append("mobile", mobile.split("").splice(-10).join(""));
    formData.append("email", email);
    formData.append("username", username);
    formData.append("country_code", mobile.split("").slice(0, -10).join(""));
    formData.append("user_type", userTypeSelect);

    // Add campus as separate key-value pairs
    if (campusId && campusId.length > 0) {
      campusId.forEach((campus) => {
        formData.append("campus", campus);
      });
    }

    // Add edu_company only for SUPER_ADMIN
    if (userType === "SUPER_ADMIN" && selectedCompanyId) {
      formData.append("edu_company", parseInt(selectedCompanyId));
    }

    try {
      const url =
        localUserType === "ADMIN_MANAGER" ||
        localUserType === "CLEANING_MANAGER" ||
        localUserType === "CLIENT"
          ? `${baseUrl}/create_user/`
          : `${baseUrl}/create_user_manager/`;
      const response = await axios(url, {
        method: "POST",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: formData,
      });
      if (response?.status === 201) {
        document.getElementById("edu-users-add-modal").click();
        setActivateEduUserAdd(false);
        setForceUpdate(!forceUpdate);
        toast.success("User added successfully!", {
          position: "top-right",
          autoClose: 2000,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  // ✅ Initial fetch
  useEffect(() => {
    if (activateEduUserAdd) {
      getCampusList();
      if (userType === "SUPER_ADMIN") getCompanyList();
    }
  }, [activateEduUserAdd]);

  return (
    <div
      className="modal fade custom-modal users-modal"
      id="add-user"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">
              {userType === "SUPER_ADMIN" ? "Add Admin" : "Add User"}
            </h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="edu-users-add-modal"
            >
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="modal-body">
            <div className="table modal-table">
              <div className="d-flex flex-column gap-3 p-3">
                {/* Row 1 */}
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-grow-1">
                    <label className="form-label">
                      First Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Last Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Email <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-grow-1">
                    <label className="form-label">
                      User Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <label className="form-label">Mobile Number</label>
                    <PhoneInput
                      country={"in"}
                      value={mobile}
                      onChange={setMobile}
                      placeholder="Mobile number"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Password <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>

                {/* Role / Company Section */}
                {userType === "SUPER_ADMIN" ? (
                  <div className="d-flex flex-wrap gap-3">
                    <div className="flex-grow-1">
                      <label className="form-label">
                        Company <i className="fa fa-star fz-12" />
                      </label>
                      <select
                        className="form-select"
                        value={selectedCompanyId}
                        onChange={(e) => setSelectedCompanyId(e.target.value)}
                      >
                        <option value="">Select Company</option>
                        {companyList.map((company) => (
                          <option key={company.id} value={company.id}>
                            {company.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex-grow-1">
                      <label className="form-label">
                        Role <i className="fa fa-star fz-12" />
                      </label>
                      <select
                        className="form-select"
                        value={userTypeSelect}
                        onChange={(e) => setUserTypeSelect(e.target.value)}
                      >
                        <option value="">Select Role</option>
                        <option value="ADMIN_MANAGER">Admin Manager</option>
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex flex-wrap gap-3">
                    <div className="flex-grow-1">
                      <label className="form-label">
                        Role <i className="fa fa-star fz-12" />
                      </label>
                      <select
                        className="form-select"
                        value={userTypeSelect}
                        onChange={(e) => setUserTypeSelect(e.target.value)}
                      >
                        <option value="">Select Role</option>
                        <option value="CLEANER">Cleaner</option>
                        {localUserType !== "CLEANING_MANAGER" &&
                          localUserType !== "CLIENT" && (
                        <option value="CLEANING_MANAGER">
                          Cleaning Manager
                        </option>
                          )}
                        {localUserType !== "CLIENT" && (
                        <option value="CLIENT">Client</option>
                        )}
                      </select>
                    </div>
                    <div className="flex-grow-1">
                      <label className="form-label">
                        College <i className="fa fa-star fz-12" />
                      </label>
                      <MultiSelectDropdown
                        options={campusList}
                        selectedValues={campusId}
                        onSelect={setCampusId}
                        placeholder="Select College"
                        selectAllText="Select All"
                        deselectAllText="Clear"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-5"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button onClick={handleSubmit} type="button" className="thm-btn">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import { baseUrl } from "../../config/baseUrl";
// import MultiSelectDropdown from "./multi-select-dropdown";
// import { Bounce, toast } from "react-toastify";

// export const EduUsersAdd = ({
//   userType,
//   forceUpdate,
//   setForceUpdate,
//   activateEduUserAdd,
//   setActivateEduUserAdd,
// }) => {
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [email, setEmail] = useState("");
//   const [username, setUsername] = useState("");
//   const [campusId, setCampusId] = useState([]); // Empty array for multiple selections
//   const [countryCode, setCountryCode] = useState(""); // Or default to "91" if needed
//   const [userTypeSelect, setUserTypeSelect] = useState("");
//   const [campusList, setCampusList] = useState([]);
//   const [res, setres] = useState([]);

//   const getCampusList = async () => {
//     let response = await axios(`${baseUrl}/get_campus/`, {
//       method: "GET",
//       headers: {
//         Authorization: "Token " + localStorage.getItem("token"),
//       },
//     });
//     setCampusList(
//       response?.data?.data?.map((m) => ({
//         id: m?.id,
//         campus_name: m?.campus_name,
//       }))
//     );
//     setres(response?.data?.data);
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = {
//       first_name: firstName,
//       last_name: lastName,
//       password: password,
//       mobile: mobile.split("").splice(-10).join(""),
//       email: email,
//       username: username,
//       campus: campusId,
//       country_code: mobile.split("").slice(0, -10).join(""),
//       user_type: "ADMIN_MANAGER",
//     };
//     let response;
//     try {
//       response = await axios(`${baseUrl}/create_user_manager/`, {
//         method: "POST",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//         data: { ...data },
//       });
//       if (response?.status === 201) {
//         let unique = document.getElementById("edu-users-add-modal");
//         unique.click();
//         setActivateEduUserAdd(false);
//         setForceUpdate(!forceUpdate);
//         toast.success("College added Successfully!!", {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "light",
//           transition: Bounce,
//         });
//       }
//     } catch (error) {
//       toast.error("Error occurred!", {
//         position: "top-right",
//         autoClose: 2000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//         transition: Bounce,
//       });
//     }
//   };

//   useEffect(() => {
//     if (activateEduUserAdd) {
//       (async function () {
//         await getCampusList();
//       })();
//     }
//   }, [activateEduUserAdd]);

//   return (
//     <div
//       className="modal fade custom-modal users-modal"
//       id="add-user"
//       tabIndex={-1}
//       aria-labelledby="exampleModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-fullscreen">
//         <div className="modal-content">
//           <div className="modal-header justify-content-center">
//             <h5 className="modal-title">
//               {userType === "ADMIN_MANAGER" ? "Add New User" : "Add Admin"}
//             </h5>
//             <button
//               type="button"
//               className="modal-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//               id="edu-users-add-modal"
//             >
//               <i className="fa fa-times" />
//             </button>
//           </div>
//           <div className="modal-body">
//             <div className="table modal-table">
//               <div className="d-flex flex-column gap-3 p-3">
//                 {/* Row 1 */}
//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       First Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="First name"
//                       name="first_name"
//                       onChange={(e) => setFirstName(e.target.value)}
//                       value={firstName}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Last Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Last name"
//                       name="last_name"
//                       onChange={(e) => setLastName(e.target.value)}
//                       value={lastName}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Email  <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       placeholder="Email"
//                       name="email"
//                       onChange={(e) => setEmail(e.target.value)}
//                       value={email}
//                       id="email"
//                     />
//                   </div>
//                 </div>

//                 {/* Row 2 */}
//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       User Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="username"
//                       name="username"
//                       onChange={(e) => setUsername(e.target.value)}
//                       value={username}
//                       id="username"
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">Mobile Number</label>
//                     <PhoneInput
//                       name="mobile"
//                       value={mobile}
//                       placeholder="Mobile number"
//                       country={"in"}
//                       onChange={(phone) => setMobile(phone)}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Password <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="password"
//                       onChange={(e) => setPassword(e.target.value)}
//                       className="form-control"
//                       placeholder="password"
//                       name="password"
//                       value={password}
//                     />
//                   </div>
//                 </div>

//                 {/* Conditional Row */}
//                 {userType === "SUPER_ADMIN" ? (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">Company</label>
//                       {res?.length > 0 ? (
//                         <select
//                           name="company"
//                           onChange={(e) => setUserTypeSelect(e.target.value)}
//                           className="form-select"
//                           value={userTypeSelect}
//                         >
//                           <option value="">Select Company  </option>
//                           {[
//                             ...new Map(
//                               res.map((item) => [item.company.id, item.company])
//                             ).values()
//                           ].map((company) => (
//                             <option key={company.id} value={company.id}>
//                               {company.name}
//                             </option>
//                           ))}
//                         </select>
//                       ) : (
//                         <p>No companies available</p>
//                       )}

//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Role <i className="fa fa-star fz-12" />
//                       </label>
//                       <select
//                         name="role_type"
//                         onChange={(e) => setUserTypeSelect(e.target.value)}
//                         className="form-select"
//                         value={userTypeSelect}
//                       >
//                         <option value="">Roles</option>
//                         <option value="CLEANER">Cleaner</option>
//                         <option value="CLEANING_MANAGER">
//                           Cleaning Manager
//                         </option>
//                         <option value="CLIENT">Client</option>
//                       </select>
//                     </div>

//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Campus <i className="fa fa-star fz-12" />
//                       </label>
//                       <MultiSelectDropdown
//                         options={campusList}
//                         selectedValues={campusId}
//                         onSelect={setCampusId}
//                         placeholder="Select Campus"
//                         selectAllText="Select All Campus"
//                         deselectAllText="Clear Selection"
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div className="modal-footer">
//             <button
//               type="button"
//               className="btn btn-outline-secondary rounded-5"
//               data-bs-dismiss="modal"
//               id="unique"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSubmit}
//               type="button"
//               className="thm-btn"
//             // data-bs-dismiss="modal"
//             >
//               Submit
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import { baseUrl } from "../../config/baseUrl";
// import MultiSelectDropdown from "./multi-select-dropdown";
// import { Bounce, toast } from "react-toastify";

// export const EduUsersAdd = ({
//   userType,
//   forceUpdate,
//   setForceUpdate,
//   activateEduUserAdd,
//   setActivateEduUserAdd,
// }) => {
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [email, setEmail] = useState("");
//   const [username, setUsername] = useState("");
//   const [campusId, setCampusId] = useState([]);
//   const [companyId, setCompanyId] = useState("");
//   const [campusList, setCampusList] = useState([]);
//   const [companyList, setCompanyList] = useState([]);

//   const getCampusList = async () => {
//     try {
//       const response = await axios(`${baseUrl}/get_campus/`, {
//         method: "GET",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//       });
//       setCampusList(
//         response?.data?.data?.map((m) => ({
//           id: m?.id,
//           campus_name: m?.campus_name,
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching campus list:", error);
//     }
//   };

//   const getCompanyList = async () => {
//     try {
//       const response = await axios(`${baseUrl}/get_superuser_company/`, {
//         method: "GET",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//       });
//       if (response?.status === 200 && response?.data?.data) {
//         setCompanyList(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching company list:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = {
//       first_name: firstName,
//       last_name: lastName,
//       password: password,
//       mobile: mobile.split("").splice(-10).join(""),
//       email: email,
//       username: username,
//       campus: campusId,
//       country_code: mobile.split("").slice(0, -10).join(""),
//       user_type: userType === "SUPER_ADMIN" ? "ADMIN_MANAGER" : companyId, // fallback logic
//       company: userType === "SUPER_ADMIN" ? companyId : undefined,
//     };

//     try {
//       const response = await axios(`${baseUrl}/create_user_manager/`, {
//         method: "POST",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//         data,
//       });

//       if (response?.status === 201) {
//         document.getElementById("edu-users-add-modal").click();
//         setActivateEduUserAdd(false);
//         setForceUpdate(!forceUpdate);
//         toast.success("User created successfully!", {
//           position: "top-right",
//           autoClose: 2000,
//           theme: "light",
//           transition: Bounce,
//         });
//       }
//     } catch (error) {
//       toast.error("Failed to create user!", {
//         position: "top-right",
//         autoClose: 2000,
//         theme: "light",
//         transition: Bounce,
//       });
//     }
//   };

//   useEffect(() => {
//     if (activateEduUserAdd) {
//       getCampusList();
//       getCompanyList();
//     }
//   }, [activateEduUserAdd]);

//   return (
//     <div
//       className="modal fade custom-modal users-modal"
//       id="add-user"
//       tabIndex={-1}
//       aria-labelledby="exampleModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-fullscreen">
//         <div className="modal-content">
//           <div className="modal-header justify-content-center">
//             <h5 className="modal-title">
//               {userType === "ADMIN_MANAGER" ? "Add New User" : "Add Admin"}
//             </h5>
//             <button
//               type="button"
//               className="modal-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//               id="edu-users-add-modal"
//             >
//               <i className="fa fa-times" />
//             </button>
//           </div>
//           <div className="modal-body">
//             <div className="table modal-table">
//               <div className="d-flex flex-column gap-3 p-3">
//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       First Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="First name"
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                     />
//                   </div>
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Last Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Last name"
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                     />
//                   </div>
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Email <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       placeholder="Email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Username <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                     />
//                   </div>
//                   <div className="flex-grow-1">
//                     <label className="form-label">Mobile Number</label>
//                     <PhoneInput
//                       value={mobile}
//                       country={"in"}
//                       onChange={setMobile}
//                       placeholder="Mobile number"
//                     />
//                   </div>
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Password <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="password"
//                       className="form-control"
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {userType === "SUPER_ADMIN" ? (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Company <i className="fa fa-star fz-12" />
//                       </label>
//                       {companyList.length > 0 ? (
//                         <select
//                           name="company"
//                           className="form-select"
//                           value={companyId}
//                           onChange={(e) => setCompanyId(e.target.value)}
//                         >
//                           <option value="">Select Company</option>
//                           {companyList.map((company) => (
//                             <option key={company.id} value={company.id}>
//                               {company.name}
//                             </option>
//                           ))}
//                         </select>
//                       ) : (
//                         <p>No companies available</p>
//                       )}
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Role <i className="fa fa-star fz-12" />
//                       </label>
//                       <select
//                         name="role_type"
//                         className="form-select"
//                         value={companyId}
//                         onChange={(e) => setCompanyId(e.target.value)}
//                       >
//                         <option value="">Select Role</option>
//                         <option value="CLEANER">Cleaner</option>
//                         <option value="CLEANING_MANAGER">Cleaning Manager</option>
//                         <option value="CLIENT">Client</option>
//                       </select>
//                     </div>
//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Campus <i className="fa fa-star fz-12" />
//                       </label>
//                       <MultiSelectDropdown
//                         options={campusList}
//                         selectedValues={campusId}
//                         onSelect={setCampusId}
//                         placeholder="Select Campus"
//                         selectAllText="Select All"
//                         deselectAllText="Clear"
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="modal-footer">
//             <button
//               type="button"
//               className="btn btn-outline-secondary rounded-5"
//               data-bs-dismiss="modal"
//             >
//               Cancel
//             </button>
//             <button onClick={handleSubmit} type="button" className="thm-btn">
//               Submit
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import { baseUrl } from "../../config/baseUrl";
// import MultiSelectDropdown from "./multi-select-dropdown";
// import { Bounce, toast } from "react-toastify";

// export const EduUsersAdd = ({
//   userType,
//   forceUpdate,
//   setForceUpdate,
//   activateEduUserAdd,
//   setActivateEduUserAdd,
// }) => {
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [password, setPassword] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [email, setEmail] = useState("");
//   const [username, setUsername] = useState("");
//   const [campusId, setCampusId] = useState([]); // Empty array for multiple selections
//   const [countryCode, setCountryCode] = useState(""); // Or default to "91" if needed
//   const [userTypeSelect, setUserTypeSelect] = useState("");
//   const [campusList, setCampusList] = useState([]);

//   const getCampusList = async () => {
//     let response = await axios(`${baseUrl}/get_campus/`, {
//       method: "GET",
//       headers: {
//         Authorization: "Token " + localStorage.getItem("token"),
//       },
//     });
//     setCampusList(
//       response?.data?.data?.map((m) => ({
//         id: m?.id,
//         campus_name: m?.campus_name,
//       }))
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = {
//       first_name: firstName,
//       last_name: lastName,
//       password: password,
//       mobile: mobile.split("").splice(-10).join(""),
//       email: email,
//       username: username,
//       campus: campusId,
//       country_code: mobile.split("").slice(0, -10).join(""),
//       user_type: userTypeSelect,
//     };
//     let response;
//     try {
//       response = await axios(`${baseUrl}/create_user/`, {
//         method: "POST",
//         headers: {
//           Authorization: "Token " + localStorage.getItem("token"),
//         },
//         data: { ...data },
//       });
//       if (response?.status === 201) {
//         let unique = document.getElementById("edu-users-add-modal");
//         unique.click();
//         setActivateEduUserAdd(false);
//         setForceUpdate(!forceUpdate);
//         toast.success("College added Successfully!!", {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "light",
//           transition: Bounce,
//         });
//       }
//     } catch (error) {
//       toast.error("Error occurred!", {
//         position: "top-right",
//         autoClose: 2000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//         transition: Bounce,
//       });
//     }
//   };

//   useEffect(() => {
//     if (activateEduUserAdd) {
//       (async function () {
//         await getCampusList();
//       })();
//     }
//   }, [activateEduUserAdd]);

//   return (
//     <div
//       className="modal fade custom-modal users-modal"
//       id="add-user"
//       tabIndex={-1}
//       aria-labelledby="exampleModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-fullscreen">
//         <div className="modal-content">
//           <div className="modal-header justify-content-center">
//             <h5 className="modal-title">
//               {userType === "ADMIN_MANAGER" ? "Add New User" : "Add Admin"}
//             </h5>
//             <button
//               type="button"
//               className="modal-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//               id="edu-users-add-modal"
//             >
//               <i className="fa fa-times" />
//             </button>
//           </div>
//           <div className="modal-body">
//             <div className="table modal-table">
//               <div className="d-flex flex-column gap-3 p-3">
//                 {/* Row 1 */}
//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       First Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="First name"
//                       name="first_name"
//                       onChange={(e) => setFirstName(e.target.value)}
//                       value={firstName}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Last Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Last name"
//                       name="last_name"
//                       onChange={(e) => setLastName(e.target.value)}
//                       value={lastName}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Email <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       placeholder="Email"
//                       name="email"
//                       onChange={(e) => setEmail(e.target.value)}
//                       value={email}
//                       id="email"
//                     />
//                   </div>
//                 </div>

//                 {/* Row 2 */}
//                 <div className="d-flex flex-wrap gap-3">
//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       User Name <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="username"
//                       name="username"
//                       onChange={(e) => setUsername(e.target.value)}
//                       value={username}
//                       id="username"
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">Mobile Number</label>
//                     <PhoneInput
//                       name="mobile"
//                       value={mobile}
//                       placeholder="Mobile number"
//                       country={"in"}
//                       onChange={(phone) => setMobile(phone)}
//                     />
//                   </div>

//                   <div className="flex-grow-1">
//                     <label className="form-label">
//                       Password <i className="fa fa-star fz-12" />
//                     </label>
//                     <input
//                       type="password"
//                       onChange={(e) => setPassword(e.target.value)}
//                       className="form-control"
//                       placeholder="password"
//                       name="password"
//                       value={password}
//                     />
//                   </div>
//                 </div>

//                 {/* Conditional Row */}
//                 {userType === "SUPER_ADMIN" ? (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">Company</label>
//                       {/* Company select dropdown would go here */}
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex flex-wrap gap-3">
//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Role <i className="fa fa-star fz-12" />
//                       </label>
//                       <select
//                         name="role_type"
//                         onChange={(e) => setUserTypeSelect(e.target.value)}
//                         className="form-select"
//                         value={userTypeSelect}
//                       >
//                         <option value="">Roles</option>
//                         <option value="CLEANER">Cleaner</option>
//                         <option value="CLEANING_MANAGER">
//                           Cleaning Manager
//                         </option>
//                         <option value="CLIENT">Client</option>
//                       </select>
//                     </div>

//                     <div className="flex-grow-1">
//                       <label className="form-label">
//                         Campus <i className="fa fa-star fz-12" />
//                       </label>
//                       <MultiSelectDropdown
//                         options={campusList}
//                         selectedValues={campusId}
//                         onSelect={setCampusId}
//                         placeholder="Select Campus"
//                         selectAllText="Select All Campus"
//                         deselectAllText="Clear Selection"
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div className="modal-footer">
//             <button
//               type="button"
//               className="btn btn-outline-secondary rounded-5"
//               data-bs-dismiss="modal"
//               id="unique"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSubmit}
//               type="button"
//               className="thm-btn"
//               // data-bs-dismiss="modal"
//             >
//               Submit
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
